// main
import type { FossaPlanNameWithEnterprise } from '../../../../../shared/subscriptions';

export const projectsFeature = 'projectsFeature';
export const contributingDevelopers = 'contributingDevelopers';
export const releaseGroupsFeature = 'releaseGroupsFeature';
export const continuousMonitoringFeature = 'continuousMonitoringFeature';
export const apiSupportFeature = 'apiSupportFeature';
export const packageIndexFeature = 'packageIndexFeature';
export const issueDashboardFeature = 'issueDashboardFeature';
export const autoIgnoreRulesFeature = 'autoIgnoreRulesFeature';
export const issueFiltersFeature = 'issueFiltersFeature';
export const savedFiltersFeature = 'savedFiltersFeature';
// codeScanning
export const sourceCodeScanningFeature = 'sourceCodeScanningFeature';
export const deepDepDiscoveryFeature = 'deepDepDiscoveryFeature';
export const quickImportGitHubFeature = 'quickImportGitHubFeature';
export const cicdIntegrationFeature = 'cicdIntegrationFeature';
export const branchTagScanningFeature = 'branchTagScanningFeature';
export const containerScanningFeature = 'containerScanningFeature';
export const archiveScanningFeature = 'archiveScanningFeature';
// security
export const vulnIdentificationFeature = 'vulnIdentificationFeature';
export const vulnManagementFeature = 'vulnManagementFeature';
export const defaultSecurityPoliciesFeature = 'defaultSecurityPoliciesFeature';
export const customizeableSecurityPoliciesFeature = 'customizeableSecurityPoliciesFeature';
export const basicIssueFilterSortFeature = 'basicIssueFilterSortFeature';
export const advancedIssueFilterSortFeature = 'advancedIssueFilterSortFeature';
// compliance
export const licenseIdentificationFeature = 'licenseIdentificationFeature';
export const licensingPolicyManagementFeature = 'licensingPolicyManagementFeature';
export const discoveredLicensesFeature = 'discoveredLicensesFeature';
export const defaultLicensePoliciesFeature = 'defaultLicensePoliciesFeature';
export const customizeableLicensePoliciesFeature = 'customizeableLicensePoliciesFeature';
// quality
export const packageHealthSignalsFeature = 'packageHealthSignalsFeature';
export const defaultQualityPoliciesFeature = 'defaultQualityPoliciesFeature';
export const customizeableQualityPoliciesFeature = 'customizeableQualityPoliciesFeature';
// sbom
export const sbomGenerationFeature = 'sbomGenerationFeature';
export const sbomImportFeature = 'sbomImportFeature';
export const sbomExportFeature = 'sbomExportFeature';
export const vexAnnotationsFeature = 'vexAnnotationsFeature';
export const appSbomFeature = 'appSbomFeature';
export const publicSbomFeature = 'publicSbomFeature';
export const privateSbomFeature = 'privateSbomFeature';
// reporting
export const attributionReportFeature = 'attributionReportFeature';
export const auditDueDiligenceReportFeature = 'auditDueDiligenceReportFeature';
export const globalBundleFeature = 'globalBundleFeature';
export const issueOverviewFeature = 'issueOverviewFeature';
// adminControl
export const auditLogsFeature = 'auditLogsFeature';
export const jiraIntegrationFeature = 'jiraIntegrationFeature';
export const slackIntegrationFeature = 'slackIntegrationFeature';
export const ssoFeature = 'ssoFeature';
export const rbacFeature = 'rbacFeature';
export const teamFeature = 'teamFeature';
// support
export const priorityEmailFeature = 'priorityEmailFeature';
export const onboardingAndSupportFeature = 'onboardingAndSupportFeature';
export const slaFeature = 'slaFeature';
// deployments
export const saasDeploymentFeature = 'saasDeploymentFeature';
export const managedSaasDeploymentFeature = 'managedSaasDeploymentFeature';
export const onPremDeploymentFeature = 'onPremDeploymentFeature';

export const mainFeatures = {
  projectsFeature,
  contributingDevelopers,
  releaseGroupsFeature,
  continuousMonitoringFeature,
  apiSupportFeature,
  packageIndexFeature,
  issueDashboardFeature,
  autoIgnoreRulesFeature,
  issueFiltersFeature,
  savedFiltersFeature,
} as const;
export type MainFeature = keyof typeof mainFeatures;

export const codeScanningFeatures = {
  sourceCodeScanningFeature,
  deepDepDiscoveryFeature,
  quickImportGitHubFeature,
  cicdIntegrationFeature,
  branchTagScanningFeature,
  containerScanningFeature,
  archiveScanningFeature,
} as const;
export type CodeScanningFeature = keyof typeof codeScanningFeatures;

export const securityFeatures = {
  vulnIdentificationFeature,
  vulnManagementFeature,
  defaultSecurityPoliciesFeature,
  customizeableSecurityPoliciesFeature,
  basicIssueFilterSortFeature,
  advancedIssueFilterSortFeature,
} as const;
export type SecurityFeature = keyof typeof securityFeatures;

export const complianceFeatures = {
  licenseIdentificationFeature,
  licensingPolicyManagementFeature,
  discoveredLicensesFeature,
  defaultLicensePoliciesFeature,
  customizeableLicensePoliciesFeature,
} as const;
export type ComplianceFeature = keyof typeof complianceFeatures;

export const qualityFeatures = {
  packageHealthSignalsFeature,
  defaultQualityPoliciesFeature,
  customizeableQualityPoliciesFeature,
} as const;
export type QualityFeature = keyof typeof qualityFeatures;

export const sbomFeatures = {
  sbomGenerationFeature,
  sbomImportFeature,
  sbomExportFeature,
  vexAnnotationsFeature,
  appSbomFeature,
  publicSbomFeature,
  privateSbomFeature,
} as const;
export type SbomFeature = keyof typeof sbomFeatures;

export const reportingFeatures = {
  attributionReportFeature,
  auditDueDiligenceReportFeature,
  globalBundleFeature,
  issueOverviewFeature,
} as const;
export type ReportingFeature = keyof typeof reportingFeatures;

export const adminControlFeatures = {
  auditLogsFeature,
  jiraIntegrationFeature,
  slackIntegrationFeature,
  ssoFeature,
  rbacFeature,
  teamFeature,
} as const;
export type AdminControlFeature = keyof typeof adminControlFeatures;

export const supportFeatures = {
  priorityEmailFeature,
  onboardingAndSupportFeature,
  slaFeature,
} as const;
export type SupportFeature = keyof typeof supportFeatures;

export const deploymentFeatures = {
  saasDeploymentFeature,
  managedSaasDeploymentFeature,
  onPremDeploymentFeature,
} as const;
export type DeploymentFeature = keyof typeof deploymentFeatures;

export type FossaFeature =
  | MainFeature
  | CodeScanningFeature
  | SecurityFeature
  | ComplianceFeature
  | QualityFeature
  | SbomFeature
  | ReportingFeature
  | AdminControlFeature
  | SupportFeature
  | DeploymentFeature;

export const featureGroups = [
  'mainFeatures',
  'codeScanningFeatures',
  'securityFeatures',
  'complianceFeatures',
  'qualityFeatures',
  'sbomFeatures',
  'reportingFeatures',
  'adminControlFeatures',
  'supportFeatures',
  'deploymentFeatures',
] as const;

export type FeatureGroups = typeof featureGroups[number];

export type FeatureDescription = {
  name: string;
  tooltipText?: string;
  isFeatureNamePlural?: boolean;
};

export type FullTierDescription = {
  mainFeatures: { [key in MainFeature]: string | boolean };
  codeScanningFeatures: { [key in CodeScanningFeature]: string | boolean };
  securityFeatures: { [key in SecurityFeature]: string | boolean };
  complianceFeatures: { [key in ComplianceFeature]: string | boolean };
  qualityFeatures: { [key in QualityFeature]: string | boolean };
  sbomFeatures: { [key in SbomFeature]: string | boolean };
  reportingFeatures: { [key in ReportingFeature]: string | boolean };
  adminControlFeatures: { [key in AdminControlFeature]: string | boolean };
  supportFeatures: { [key in SupportFeature]: string | boolean };
  deploymentFeatures: { [key in DeploymentFeature]: string | boolean };
};

export type FullFeatureDescriptions = {
  mainFeatures: { [key in MainFeature]: FeatureDescription };
  codeScanningFeatures: { [key in CodeScanningFeature]: FeatureDescription };
  securityFeatures: { [key in SecurityFeature]: FeatureDescription };
  complianceFeatures: { [key in ComplianceFeature]: FeatureDescription };
  qualityFeatures: { [key in QualityFeature]: FeatureDescription };
  sbomFeatures: { [key in SbomFeature]: FeatureDescription };
  reportingFeatures: { [key in ReportingFeature]: FeatureDescription };
  adminControlFeatures: { [key in AdminControlFeature]: FeatureDescription };
  supportFeatures: { [key in SupportFeature]: FeatureDescription };
  deploymentFeatures: { [key in DeploymentFeature]: FeatureDescription };
};

export type MessageOptions = {
  focusFeature?: FossaFeature;
  tier?: FossaPlanNameWithEnterprise;
};

export const featureDescriptions: FullFeatureDescriptions = {
  mainFeatures: {
    [projectsFeature]: {
      name: 'Projects',
    },
    [contributingDevelopers]: {
      name: 'Contributing Developers',
    },
    [releaseGroupsFeature]: {
      name: 'Release Groups',
      tooltipText: 'Bundle multiple projects to track as a group.',
    },
    [continuousMonitoringFeature]: {
      name: 'Continuous Monitoring',
      tooltipText: 'Automatic alerting for new licensing and security issues.',
    },
    [apiSupportFeature]: {
      name: 'API Support',
      tooltipText: 'Build custom integrations and workflows with our API.',
    },
    [packageIndexFeature]: {
      name: 'Package Index',
      tooltipText: 'Organization-wide package dashboard for all package versions from scanned projects.',
    },
    [issueDashboardFeature]: {
      name: 'Issue History Dashboard',
      tooltipText: 'Historical overview of new and remediated issues.',
    },
    [autoIgnoreRulesFeature]: {
      name: 'Ignore Rules',
      tooltipText: 'Define rules to automatically ignore specific issues, reducing noise and focusing on critical items.',
    },
    [issueFiltersFeature]: {
      name: 'Issue Filters',
      tooltipText: 'Apply filters to quickly sort and find issues based on severity, status, or other criteria.',
    },
    [savedFiltersFeature]: {
      name: 'Saved Filters',
      tooltipText: 'Save a group of filters for simple reuse.',
    },
  },
  codeScanningFeatures: {
    [sourceCodeScanningFeature]: {
      name: 'Source Code Scanning',
      tooltipText: 'Scan your source code for vulnerabilities, license issues, and compliance risks.',
    },
    [deepDepDiscoveryFeature]: {
      name: 'Transitive Dependency Discovery',
      tooltipText: 'Discover indirect dependencies in your project to ensure full license and security compliance.',
    },
    [quickImportGitHubFeature]: {
      name: 'Quick Import (GitHub)',
      tooltipText: 'Integrate at source with your hosted code repository.',
    },
    [cicdIntegrationFeature]: {
      name: 'CI/CD Integration (CLI)',
      tooltipText: 'Integrate within CI/CD w/ CLI.',
    },
    [branchTagScanningFeature]: {
      name: 'Branch/Tag Scanning',
      tooltipText: 'Scan a specific branch or tag within a project repo.',
    },
    [containerScanningFeature]: {
      name: 'Container Scanning',
      tooltipText: 'Scan your container images for vulnerabilities, compliance issues, and security risks.',
    },
    [archiveScanningFeature]: {
      name: 'Archive Scanning',
      tooltipText: 'Scan the contents of archived files for vulnerabilities, license issues, and compliance risks.',
    },
  },
  securityFeatures: {
    [vulnIdentificationFeature]: {
      name: 'Vulnerability Identification',
      tooltipText: 'Identify security vulnerabilities in your codebase.',
    },
    [vulnManagementFeature]: {
      name: 'Vulnerability Management',
      tooltipText: 'Track, and resolve security vulnerabilities in your codebase.',
    },
    [defaultSecurityPoliciesFeature]: {
      name: 'Default Security Policies',
      tooltipText: 'Preset rules to identify all severity vulnerabilities in your code.',
    },
    [customizeableSecurityPoliciesFeature]: {
      name: 'Custom Security Policies',
      tooltipText: 'Customizable rules to identify vulnerabilities in your code based on your organizational needs.',
    },
    [basicIssueFilterSortFeature]: {
      name: 'Basic Issue Filters/Sorts',
      tooltipText: 'Depth, Severity, CWE, Reachability',
    },
    [advancedIssueFilterSortFeature]: {
      name: 'Advanced Issue Filters/Sorts',
      tooltipText: 'EPSS, Upgrade Distance, Ticket status, Exploit Maturity (KEV)',
    },
  },
  complianceFeatures: {
    [licenseIdentificationFeature]: {
      name: 'License Compliance Identification',
      tooltipText: 'View license compliance requirements.',
    },
    [licensingPolicyManagementFeature]: {
      name: 'License Compliance Management',
      tooltipText: 'Streamline tracking and management of open source licenses for legal compliance.',
    },
    [discoveredLicensesFeature]: {
      name: 'Discovered licenses',
      tooltipText: 'Automatically discover open source licenses within your codebase for compliance.',
    },
    [defaultLicensePoliciesFeature]: {
      name: 'Default License Policies',
      tooltipText: 'Preset rules to identify common license issues in your code.',
    },
    [customizeableLicensePoliciesFeature]: {
      name: 'Custom License Policies',
      tooltipText: 'Customizable rules to identify issues in your code based on your organizational needs.',
    },
  },
  qualityFeatures: {
    [packageHealthSignalsFeature]: {
      name: 'Package Health Signals',
      tooltipText: 'Package reliability with health indicators like maintenance and security.',
    },
    [defaultQualityPoliciesFeature]: {
      name: 'Default Quality Policies',
      tooltipText: 'Enforce consistent quality standards across projects with predefined rules for packages.',
    },
    [customizeableQualityPoliciesFeature]: {
      name: 'Custom Quality Policies',
      tooltipText: 'Customizable rules to identify issues in your code based on your organizational needs.',
    },
  },
  sbomFeatures: {
    [sbomGenerationFeature]: {
      name: 'SBOM Generation (SPDX, CycloneDX)',
      tooltipText: 'Generate a NTIA-compliant SBOM in either SPDX or CycloneDX.',
    },
    [sbomImportFeature]: {
      name: 'SBOM Import',
      tooltipText: 'Import SBOMs from your third party suppliers or from other scanning tools.',
    },
    [sbomExportFeature]: {
      name: 'SBOM Export',
      tooltipText: 'Export generated SPDX and CycloneDX SBOMs in .JSON or .CSV formats.',
    },
    [vexAnnotationsFeature]: {
      name: 'Automated VEX Annotations',
      tooltipText: 'Automatically enrich your SBOMs with the latest vulnerability information.',
    },
    [appSbomFeature]: {
      name: 'Application SBOM',
      tooltipText: 'Generate an application-level SBOM, covering multiple repositories and imported SBOMs.',
    },
    [publicSbomFeature]: {
      name: 'Public SBOM Distribution Portal',
      tooltipText: 'Host your SBOMs on a custom public FOSSA subdomain.',
    },
    [privateSbomFeature]: {
      name: 'Private SBOM Distribution Portal w/ time-based access tokens',
      tooltipText: 'Host your SBOMs on a private custom FOSSA subdomain.',
    },
  },
  reportingFeatures: {
    [attributionReportFeature]: {
      name: '3rd-Party Attribution Report (Project Level)',
      tooltipText: 'Generate a report to attribute third-party component usage for compliance.',
    },
    [auditDueDiligenceReportFeature]: {
      name: 'Audit/Due Diligence Report',
      tooltipText: 'An organization-wide report on Issues and project changes.',
    },
    [globalBundleFeature]: {
      name: 'Global Component Bundle',
      tooltipText: 'An organization-wide report on licenses and packages.',
    },
    [issueOverviewFeature]: {
      name: 'Issue Overview',
      tooltipText: 'Issue health report for tracking issue history over-time.',
    },
  },
  adminControlFeatures: {
    [auditLogsFeature]: {
      name: 'Audit Logs',
      tooltipText: 'Monitor account activity and track changes for security and compliance.',
    },
    [jiraIntegrationFeature]: {
      name: 'Jira Integration',
      tooltipText: 'Export and link FOSSA issues to JIRA tickets.',
    },
    [slackIntegrationFeature]: {
      name: 'Slack Integration',
      tooltipText: 'Publish issue notifications to Slack Channels.',
    },
    [ssoFeature]: {
      name: 'Single Sign-On (SSO)',
      tooltipText: 'Single Sign On support for G-Suite, Okta, Auth0, AD and LDAP.',
    },
    [rbacFeature]: {
      name: 'Roles based access controls (RBAC)',
      tooltipText: 'Granular role based permissions for FOSSA features.',
    },
    [teamFeature]: {
      name: 'Teams',
      tooltipText: 'Group projects together under a team umbrella.',
      isFeatureNamePlural: true,
    },
  },
  supportFeatures: {
    [priorityEmailFeature]: {
      name: 'Priority Email Support',
      tooltipText: 'Email support from our Customer Success team.',
    },
    [onboardingAndSupportFeature]: {
      name: 'Customer Success Manager & Engineer',
      tooltipText: 'Support for your team from a Customer Success Manager.',
    },
    [slaFeature]: {
      name: 'Service Level Agreements (SLAs)',
      tooltipText: 'Contracted service expectations, standards and remediation.',
    },
  },
  deploymentFeatures: {
    [saasDeploymentFeature]: {
      name: 'SaaS (multi-tenant cloud)',
      tooltipText: 'Access to a shared FOSSA cloud instance.',
    },
    [managedSaasDeploymentFeature]: {
      name: 'Managed SaaS (single-tenant cloud)',
      tooltipText: 'Managed dedicated FOSSA cloud instance.',
    },
    [onPremDeploymentFeature]: {
      name: 'On-premise',
      tooltipText: 'Deploy FOSSA to on-premises hardware.',
    },
  },
};

export const getFeatureDetails = (feature?: FossaFeature): FeatureDescription | null => {
  if (!feature) {
    return null;
  }

  const descriptionGroupKeys = Object.keys(featureDescriptions);
  const featureGroup = descriptionGroupKeys.find((group) =>
    Object.keys(
      featureDescriptions[group as keyof FullFeatureDescriptions],
    ).includes(feature),
  );

  // @ts-expect-error We know the typings are correct because of how we generate
  return featureGroup ? featureDescriptions[featureGroup][feature] : null;
};
